import loadable from '@loadable/component';
import React from 'react';
import PropTypes from 'prop-types';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "extra" */ '../../../reviews')
);

const UserReviewsLoader = props => {
  // Data not loaded
  if (!props.pageInfo) {
    return null;
  }

  return <LoadableComponent {...props} />;
};

UserReviewsLoader.propTypes = {
  pageInfo: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

UserReviewsLoader.defaultProps = {
  pageInfo: undefined,
};

export default UserReviewsLoader;
